import {
    List,
    Create,
    Edit,
    SimpleForm,
    TextInput,
    TextField,
    DateField,
    Resource,
    Show,
    ReferenceInput,
    Filter,
    ReferenceField,
    AutocompleteInput,
    Datagrid,
    SimpleShowLayout,
    NumberField,
    NumberInput,
    useRecordContext,
    useRedirect
} from "react-admin";
import VersionedList, { DbVersionFilterInput, DbVersionField, DbVersionInput } from "../components/DbVersion";

const MaterialGroupLinkField = () => {
    const record = useRecordContext();
    const redirect = useRedirect();
    
    if (!record || !record.materialsGroup) return null;
    
    const handleClick = (e) => {
        e.stopPropagation(); // Esto evita que el evento llegue al Datagrid
        redirect('show', 'materialsGroup', record.materialsGroup.id);
    };
    
    return (
        <span 
            onClick={handleClick}
            style={{ 
                color: '#3f51b5', 
                cursor: 'pointer',
                textDecoration: 'none'
            }}
        >
            {record.materialsGroup.name}
        </span>
    );
};

const Filters = (props) => (
    <Filter {...props}>
        <ReferenceInput alwaysOn label="Raw material category" source="rawMaterialCategoryId" reference="rawMaterialCategory" filterToQuery={searchText => ({ name: searchText })} >
            <AutocompleteInput optionText="name" />
        </ReferenceInput>

        <ReferenceInput alwaysOn label="Material group" source="materialGroupId" reference="materialsGroup" filterToQuery={searchText => ({ name: searchText })} >
            <AutocompleteInput optionText="name" />
        </ReferenceInput>

        <DbVersionFilterInput alwaysOn />
    </Filter>
);

const RawMaterialCategoryMaterialGroupList = (props) => {
    return (
        <VersionedList {...props} filters={Filters(props)}>
            <div style={{ marginTop: '15px' }}>
                <Datagrid rowClick="show">
                    <TextField source="id" />
                    <DbVersionField />

                    <ReferenceField label="Raw material category" source="rawMaterialCategoryId" reference="rawMaterialCategory">
                        <TextField source="name" />
                    </ReferenceField>


                    <MaterialGroupLinkField label="Material group" source="materialsGroup" />

                    <NumberField source="Default_material_processing_loss_rate" label="Processing loss rate" />
                    <TextField source="Default_material_processing_loss_rate_source" label="Processing loss rate source" />

                    <DateField source="createdAt" label="Creation date" />
                    <DateField source="updatedAt" label="Update date" />
                </Datagrid>
            </div>
        </VersionedList>
    );
};

const ShowRawMaterialCategoryMaterialGroup = (props) => {
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="id" />

                <ReferenceField label="Raw material category" source="rawMaterialCategoryId" reference="rawMaterialCategory">
                    <TextField source="name" />
                </ReferenceField>

                <MaterialGroupLinkField label="Material group" />

                <NumberField source="Default_material_processing_loss_rate" label="Processing loss rate" />
                <TextField source="Default_material_processing_loss_rate_source" label="Processing loss rate source" />

                <DateField source="createdAt" label="Creation date" />
                <DateField source="updatedAt" label="Update date" />
            </SimpleShowLayout>
        </Show>
    );
};

const CreateRawMaterialCategoryMaterialGroup = (props) => {
    return (
        <Create {...props}>
            <SimpleForm>
                <DbVersionInput />
                <ReferenceInput label="Raw material category" source="rawMaterialCategoryId" reference="rawMaterialCategory" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput optionText="name" required={true} />
                </ReferenceInput>

                <ReferenceInput label="Material group" source="materialGroupId" reference="materialsGroup" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput optionText="name" required={true} />
                </ReferenceInput>

                <NumberInput source="Default_material_processing_loss_rate" label="Processing loss rate" required={true} />
                <TextInput source="Default_material_processing_loss_rate_source" label="Processing loss rate source" />
            </SimpleForm>
        </Create>
    );
};

const EditRawMaterialCategoryMaterialGroup = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm>
                <DbVersionInput />
                <ReferenceInput label="Raw material category" source="rawMaterialCategoryId" reference="rawMaterialCategory" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput optionText="name" required={true} />
                </ReferenceInput>

                <ReferenceInput label="Material group" source="materialGroupId" reference="materialsGroup" filterToQuery={searchText => ({ name: searchText })}>
                    <AutocompleteInput optionText="name" required={true} />
                </ReferenceInput>

                <NumberInput source="Default_material_processing_loss_rate" label="Processing loss rate" required={true} />
                <TextInput source="Default_material_processing_loss_rate_source" label="Processing loss rate source" />
            </SimpleForm>
        </Edit>
    );
};

const rawMaterialCategoryMaterialGroupResource = () => <Resource
    name="rawMaterialCategoryMaterialGroup"
    options={{ label: 'Raw material category material group', menuGroup: 'Bcome' }}
    list={RawMaterialCategoryMaterialGroupList}
    create={CreateRawMaterialCategoryMaterialGroup}
    edit={EditRawMaterialCategoryMaterialGroup}
    show={ShowRawMaterialCategoryMaterialGroup} />;

export default rawMaterialCategoryMaterialGroupResource;
